<template>
  <div>
    <div class="row" style="margin-top: 20px">
      <div class="col-md-12 col-sm-12 text-center">
        <div class="botaoNovo">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#dialogEditPlano"
            @click="itemNovo()"
          >
            Novo
          </button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 20px">
      <div class="col col-md-8 offset-md-2 col-sm-12 text-center">
        <div class="d-flex justify-content-center">
          <Combo
            :itens="$global.sites_filtro()"
            v-model="filtroSite"
            style="max-width: 150px; margin-right: 10px"
            @change="carregarItens"
            v-if="
              retornaSite() !== '7live' &&
              retornaSite() !== 'Share' &&
              retornaSite() !== 'Stream1x2'
            "
          />

          <input
            class="form-control inputPesquisa"
            type="text"
            placeholder="Pesquise..."
            v-model="filtroTexto"
            @keyup="keyupFiltroTexto"
            style="min-width: 300px; margin-right: 10px"
          />
        </div>

        <hr />

        <div class="rowLista">
          <div
            class="list-group-item list-group-item-action"
            v-for="item in itens"
            :key="item.id"
            :item="item"
          >
            <div class="row">
              <div class="col col-md-12">
                <a
                  data-toggle="modal"
                  @click="editarItem(item._id)"
                  data-target="#dialogEditPlano"
                  role="button"
                >
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{ item.nome }}</h5>
                  </div>
                  <div>
                    <p
                      class="
                        text-secondary
                        textoResumo
                        d-flex
                        w-100
                        justify-content-between
                      "
                    >
                      <small
                        >{{ item.duracao }} dia(s)
                        <span v-if="retornaSite() == 'Weddbets' && item.tipo">
                          | {{ item.tipo }}</span
                        ><span v-if="retornaSite() == '7live' && item.valor">
                          | € {{ item.valor }}</span
                        ></small
                      >
                      <small>{{
                        retornaSite() !== "Share" &&
                        retornaSite() !== "Stream1x2" &&
                        retornaSite() !== "7live"
                          ? item.site
                          : ""
                      }}</small>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="rowPaginacao" style="margin-top: 15px">
          <Paginacao
            ref="paginacao"
            :total="itensTotal"
            :limit="itensLimit"
            @change-pagina="carregarItens"
          />
        </div>

        <EditPlano ref="editItem" @save-item="carregarItens" />
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import EditPlano from "../edits/EditPlano.vue";

import Paginacao from "../components/Paginacao.vue";
import Combo from "../components/Combo.vue";

export default {
  name: "ListPlanos",
  components: { EditPlano, Paginacao, Combo },
  props: { itensLimit: { type: Number, default: 50 } },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarItens() {
      var filtros = "";

      filtros +=
        "?_limit=" + this.itensLimit + "&_page=" + this.$refs.paginacao.pagina;

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroSite !== "Todos") {
        filtros += "&site=" + this.filtroSite;
      }

      filtros += "&_ordem=" + this.ordem;

      const response = await api.get("/plano" + filtros);
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      this.itensTotal = response.data.total;
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
  },
  mounted() {
    this.carregarItens();
  },
  data: function () {
    return {
      filtroTexto: "",
      filtroSite: "Todos",
      ordem: "vencimento_ASC",
      itens: [],
      itensTotal: 0,
      editItem: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
